import { render } from "./StudyProblemsCategoryPortal.vue?vue&type=template&id=0fdac84e&scoped=true"
import script from "./StudyProblemsCategoryPortal.vue?vue&type=script&lang=js"
export * from "./StudyProblemsCategoryPortal.vue?vue&type=script&lang=js"

import "./StudyProblemsCategoryPortal.vue?vue&type=style&index=0&id=0fdac84e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdac84e"]])

export default __exports__